import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface UserProps {
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
}

export const User = types.model({
  email: types.maybe(types.string),
  firstName: types.maybe(types.string),
  lastName: types.maybe(types.string),
  phoneNumber: types.maybe(types.string),
});

export type UserSnapshot = SnapshotIn<typeof User>;
export type UserInstance = Instance<typeof User>;
